import './App.css';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

let Login = () => {
    const [name, setName] = useState('');
    const [mail, setMail] = useState('');
    const [dept, setDept] = useState('');
    const [textA, setTextA] = useState('');
    const [link, setLink] = useState('');
    const [links, setLinks] = useState([]);
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleLinks = () => {
        if (link.trim() !== '') {
            setLinks([...links, link.trim()]);
            setLink('');
        }
    };

    const handleImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    useEffect(() => {
        return () => {
            if (preview) URL.revokeObjectURL(preview);
        };
    }, [preview]);

    const handleSubmit = () => {
        if (name && mail && dept && links.length > 0 && image) {
            console.log("Submitted Successfully!!!");
            setMessage("Form submitted successfully!");
        } else {
            setMessage("Please fill out all fields!");
        }
    };

    const handleGen = () => {
        if(message==="Form submitted successfully!"){
            const data={
                name, mail, dept, textA, image,links,
            }

            navigate('/generate', {state:data});
        }
        
    };

    return (
        <div className="Login">
            <h1 className="LoginText">Give User Details</h1>
            
            <input
                type="text"
                className="LogInput"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
            />

            <input
                type="text"
                className="LogInput"
                placeholder="Mail ID"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                required
            />

            <input
                type="text"
                className="LogInput"
                placeholder="Department"
                value={dept}
                onChange={(e) => setDept(e.target.value)}
                required
            />

            <div className="Links">
                <input
                    type="text"
                    placeholder="Enter project links"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                    required
                />
                <button onClick={handleLinks}>Add+</button>
            </div>

            <textarea
                className='AddCmnts'
                value={textA}
                onChange={(e) => setTextA(e.target.value)}
                placeholder="Enter additional details here"
            />

            <div className="Links">
                <input type="file" accept="image/*" onChange={handleImage} />
                {preview && (
                    <div>
                        <img src={preview} alt="Preview" width="200px" />
                    </div>
                )}
            </div>

            <button onClick={handleSubmit} className="SubmitButton" >
                Submit
            </button>
            
            {message && <p>{message}</p>}

            <button className="GenerateButton" onClick={handleGen}>
                Generate
            </button>
        </div>
    );
};

export default Login;
